import { find, includes } from 'lodash';

import {
  formatParameters,
  IFormatParameters,
} from '../../Visualization/formatParameters';
import { Timescale } from '../../../types/models';

// Per-column formats of the Uptake & Event Assumptions tab, whose columns each carry their own format
export const upTakeEventAssumptionsFormatKey = (
  timescale?: Timescale
): Record<string, IFormatParameters | undefined> => ({
  'Start Date': find(formatParameters, {
    formatKey: includes([Timescale.Monthly, Timescale.Weekly], timescale)
      ? 4
      : 0,
  }),
  'Peak Value': find(formatParameters, { formatKey: 28 }),
  'Years to Peak': find(formatParameters, { formatKey: 0 }),
  'Curve Type': find(formatParameters, { formatKey: 14 }),
  'Start Month': find(formatParameters, { formatKey: 0 }),
  'Event On/Off': find(formatParameters, { formatKey: 0 }),
});

const NUMERIC_PATTERN = /^[+-]?(\d+\.?\d*|\.\d+)(e[+-]?\d+)?$/i;
const DATE_PATTERN = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;

const isValidDate = (value: string): boolean => {
  const match = DATE_PATTERN.exec(value);
  if (!match) {
    return false;
  }
  const [month, day, year] = [match[1], match[2], match[3]].map(Number);
  const date = new Date(year, month - 1, day);
  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
};

// Returns an error description when the value isn't acceptable for the format, otherwise undefined.
// Mirrors Edit Assumptions, where Currency/Percent cells only take numbers and Date cells only take
// a picked date; General cells accept free text there, so they aren't checked here either.
export const validateUploadedValue = (
  value: string,
  formatKey?: IFormatParameters
): string | undefined => {
  switch (formatKey?.numberType) {
    case '$':
    case 'Percent':
      return NUMERIC_PATTERN.test(value) ? undefined : 'must be a number';
    case 'Date':
      return isValidDate(value) ? undefined : 'must be a date (M/d/yyyy)';
    default:
      return undefined;
  }
};
